// utils
import axios from '../../../utils/axios';

const getRates = async (type, typeId) => {
  try {
    const response = await axios({
      method: 'get',
      url: `/lexus/wallet/api/wallet/rates/get`,
      params: { type, typeId },
    });
    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(JSON.stringify(error));
  }
};

export { getRates };
